import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/doctors-pending',
            name: 'doctors-pending',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')
            },
            component: () =>
                import('./DoctorsPending/DoctorsPending.vue')
        },
        {
            path: '/doctors-registered',
            name: 'doctors-registered',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./DoctorsRegistered/DoctorsRegistered.vue')
        },
        {
            path: '/doctor-report',
            name: 'doctor-report',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')
            },
            component: () =>
                import('./DoctorReport/DoctorReport.vue')
        },
        {
            path: '/pages-doctor/:id/:name',
            name: 'pages-doctor',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./AdminVisionDoctor/AdminVisionDoctor.vue')
        },
        {
            path: '/quicksight-doctor-dashboard',
            name: 'quicksight-doctor-dashboard',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()
            },
            component: () =>
                import('./QuicksightDoctor/QuicksightDoctor.vue')
        },

    ]
}
export default [
    routes
]

